import React from 'react'
import { Dialog, DialogActions, DialogContent } from "@material-ui/core"
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import { AppCoopAssociationCard } from '../card/cooperating'

export const ConfirmDialog = ({ associationData, open, onClose }) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  //console.info(associationData)
  if(associationData) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        fullScreen={fullScreen}
        aria-labelledby="confirm-dialog">
        <DialogContent>
        <AppCoopAssociationCard associationData={associationData} />
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    )
  } else {
    return (
      <div></div>
    )
  }

}
